/* eslint-disable func-names */
import store from '@/store'
import Api from './apiMexc'
import { decodeKline, ensureProtobufInitialized } from '../protobufUtils'

const wsApi = new Api()

// Função para calcular variação percentual de 24h
const calculate24hChange = (currentPrice, openPrice) => {
  if (!openPrice || openPrice <= 0) return null

  const change = openPrice - currentPrice
  const changePercent = Number(((change / openPrice) * 100).toFixed(2))

  return {
    change,
    changePercent,
    isPositive: changePercent <= 0,
  }
}

const subscribeSymbol = function (symbol) {
  // ✅ Kline stream - dados de candlestick em tempo real
  wsApi.onKline(symbol, 'Day1', async klineData => {
    // Garantir que protobuf está inicializado
    await ensureProtobufInitialized()

    // Processar dados usando protobuf se disponível
    let processedData = null

    if (klineData && typeof klineData === 'object') {
      // Se já é um objeto JavaScript (já decodificado)
      if (klineData.kline) {
        processedData = {
          symbol: klineData.symbol,
          kline: klineData.kline,
          channel: klineData.channel,
          createTime: klineData.createtime,
        }
      } else if (klineData instanceof ArrayBuffer || klineData instanceof Uint8Array) {
        // Se é um buffer protobuf, decodificar
        processedData = decodeKline(klineData)
      }
    }

    // Processar apenas se temos kline válido
    if (processedData && processedData.kline) {
      const { kline } = processedData
      const closingPrice = parseFloat(kline.closingPrice || 0)
      const openingPrice = parseFloat(kline.openingPrice || 0)

      if (closingPrice > 0 && openingPrice > 0) {
        // Calcular variação de 24h usando preço de abertura vs fechamento do mesmo kline
        const change24h = calculate24hChange(closingPrice, openingPrice)

        const tick = {
          symbol,
          price: closingPrice.toString(),
          time: kline.windowend || Date.now(),
          // Adicionar informações adicionais do kline
          open: openingPrice,
          high: parseFloat(kline.highestPrice || 0),
          low: parseFloat(kline.lowestPrice || 0),
          volume: parseFloat(kline.volume || 0),
          amount: parseFloat(kline.amount || 0),
          interval: kline.interval,
          windowStart: kline.windowStart,
          windowEnd: kline.windowEnd,
          // Adicionar dados de variação de 24h
          change24h,
          // Preços para referência
          currentPrice: closingPrice,
          openPrice24h: openingPrice,
          // Campos necessários para o componente NovaOperacao.vue
          percent: change24h ? change24h.changePercent : 0,
        }

        store.dispatch('mexcSpot/updateTicket', tick)
      }
    }
  })
}

const unSubscribeSymbol = function (symbol) {
  wsApi.closeSubscription('kline', symbol, 'Day1')
}

export {
  subscribeSymbol,
  unSubscribeSymbol,
}
